import { render } from "./AcessibilidadeComponent.vue?vue&type=template&id=6aa006c3&scoped=true"
import script from "./AcessibilidadeComponent.vue?vue&type=script&lang=js"
export * from "./AcessibilidadeComponent.vue?vue&type=script&lang=js"

import "./AcessibilidadeComponent.vue?vue&type=style&index=0&id=6aa006c3&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa006c3"]])

export default __exports__